// React
import React from 'react';
import { Controller } from 'react-hook-form';
import BASESvgIcon from '../../../../../../@BASE/core/BASESvgIcon';
// material-ui components
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';
import MediaAttribution from '../shared/MediaAttribution';
import TextField from '@mui/material/TextField';
// custom components
import SuppEmentorArray from './components/SuppEmentorArray';
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import ImageAttribution from '../shared/ImageAttribution';
import SuppMCLureArray from '../shared/SuppMCLureArray';
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";

const PEInformativeEvent = (props) => {
  const { control, formState, watch, setValue } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  const renderIns = (type_id) => {
    switch (type_id) {
      case 0:
        return "Enter the instructions for viewing the email.";
      case 1:
        return "Enter the instructions for listening to the voicemail.";
      case 2:
        return "Enter the instructions for viewing the memo.";
      case 3:
        return "Enter the instructions for viewing the text message.";
      case 4:
        return "Enter the instructions for listening to the NPC.";
      default:
        return "Enter the instructions for the event.";
    }
  }
  
  const renderRecipient = (type_id) => {
    switch (type_id) {
      case 1:
        return "Caller";
      case 4:
        return "Speaker";
      default:
        return "Sender";
    }
  }

  const renderRecipientIns = (type_id) => {
    switch (type_id) {
      case 1:
        return "Enter the caller's name/title.";
      case 4:
        return "Enter the name of the person speaking.";
      default:
        return "Enter the sender's name/title.";
    }
  }

  const renderSubjectDesc = (type_id) => {
    switch (type_id) {
      case 0:
        return "This is the subject of the e-mail.";
      case 2:
        return "This is the subject of the memo.";
    }
  }


  const renderTaskNumber = (type_id) => {
    switch (type_id) {
      case 0:
        return "5";
      case 1:
        return "4";
      case 2:
        return "6";
      case 3:
        return "6";
      case 4:
        return "6";
      default:
        return "6";
    }
  }

  return (
    <div>

      <NumberedHeading number="1" title="Content Type" instructions="Select the type of content." />
      <Controller
        control={control}
        name="content.core.type_id"
        render={({ field }) => (
          <Controller
            control={control}
            name="content.core.type_id"
            render={({ field }) => (
              <FormControl fullWidth className="mt-16" error={!!errors.content?.core?.type_id}>
                <Select
                  {...field}
                  id="type_id"
                  classes={{ select: "flex items-center space-x-12" }}
                  displayEmpty
                  inputProps={{ "aria-label": "Content Type" }}
                  required
                >
                  <MenuItem value="" disabled className="space-x-12">
                    Select a content type
                  </MenuItem>
                  <MenuItem value={0} className="space-x-12">
                    Email
                  </MenuItem>
                  <MenuItem value={1} className="space-x-12">
                    Voicemail
                  </MenuItem>
                  <MenuItem value={2} className="space-x-12">
                    Memo/Note
                  </MenuItem>
                  <MenuItem value={3} className="space-x-12">
                    Text Message/IM
                  </MenuItem>
                  <MenuItem value={4} className="space-x-12">
                    NPC Interaction
                  </MenuItem>
                </Select>
                {!!errors.content?.core?.type_id && (
                  <FormHelperText>{errors.content?.core?.type_id?.message}</FormHelperText>
                )}
              </FormControl>
            )}
          />
        )}
      />

      <Divider className="my-16" />

      {watch(`content.core.type_id`) === "" ? (
        <div className="w-100 mx-32 my-96">
          <div className="flex items-center justify-center">
            <BASESvgIcon size={24}>heroicons-outline:exclamation</BASESvgIcon>
            <Typography className="text-16 p-16">
              Please select a content type.
            </Typography>
          </div>
        </div>
      ) : (
        <>
          <NumberedHeading number="2" title="Instructions" instructions={renderIns(watch(`content.core.type_id`))} required />
          <Controller
            control={control}
            name="content.core.instructions"
            render={({ field }) => (
              <>
                <TextField
                  {...field}
                  className="mt-16 mb-16"
                  label="Instructions"
                  placeholder="Instructions"
                  error={!!errors.content?.core?.instructions}
                  helperText={errors.content?.core?.instructions?.message}
                  fullWidth
                  multiline
                  minRows={5}
                  maxRows={10}
                  required
                  dir={inputDir}
                />
              </>
            )}
          />

          <Divider className="my-16" />

          <NumberedHeading number="3" title={renderRecipient(watch(`content.core.type_id`))} instructions={renderRecipientIns(watch(`content.core.type_id`))} required />
          <Controller
            control={control}
            name="content.core.sender"
            render={({ field }) => (
              <TextField
                className="mt-16"
                {...field}
                label={renderRecipient(watch(`content.core.type_id`))}
                placeholder={renderRecipient(watch(`content.core.type_id`))}
                id="sender"
                error={!!errors.content?.core?.sender}
                helperText={errors.content?.core?.sender?.message}
                variant="outlined"
                fullWidth
                required
              />
            )}
          />

          {(watch(`content.core.type_id`) === 0 || watch(`content.core.type_id`) === 2 || watch(`content.core.type_id`) === 3) && (
            <>
              <NumberedHeading number="4" title="Language Check Box" instructions="Check if the content is in the TL." />
              <Controller
                control={control}
                name="content.core.tl"
                render={({ field }) => (
                  <FormControlLabel
                    control={
                      <Checkbox 
                        onChange={(ev) => {
                          field.onChange(ev.target.checked);
                        }}
                        checked={field.value}
                      />
                    }
                    label='Target Language'
                  />
                )}
              />

              <Divider className="my-16" />
              
              {(watch(`content.core.type_id`) !== 3 && (
                <>
                  <NumberedHeading number="5" title="Subject" instructions={renderSubjectDesc(watch(`content.core.type_id`))} required />
                  <Controller
                    control={control}
                    name="content.core.subject"
                    render={({ field }) => (
                      <TextField
                        className="mt-16"
                        {...field}
                        label="Subject"
                        placeholder="Subject"
                        id="subject"
                        error={!!errors.content?.core?.subject}
                        helperText={errors.content?.core?.subject?.message}
                        variant="outlined"
                        fullWidth
                        required
                      />
                    )}
                  />
                </>
              ))}

              <Divider className="my-16" />

              {(watch(`content.core.type_id`) === 3 ? (
                <NumberedHeading number="5" title="Body" instructions="Enter the body of the message being delivered." required />
              ) : (
                <NumberedHeading number="6" title="Body" instructions="Enter the body of the message being delivered." required />
              ))}
              <Controller
                control={control}
                name="content.core.body"
                render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.core?.body} />}
              />
            </>
          )}

          {(watch(`content.core.type_id`) === 1) && (
            <>
              <NumberedHeading number="3" title="Transcript" instructions="Enter the transcript of the voicemail." required />
              <Controller
                control={control}
                name="content.core.transcript"
                render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.core?.transcript} />}
              />
            </>
          )}

          {(watch(`content.core.type_id`) === 4) && (
            <>
              <NumberedHeading number="3" title="Speaker description" instructions="Enter a description of the NPC." required />
              <Controller
                control={control}
                name="content.core.sender_desc"
                render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.core?.sender_desc} />}
              />

              <Divider className="my-16" />

              <NumberedHeading number="4" title="Statement" instructions="Enter the text of the NPC's statement." required />
              <Controller
                control={control}
                name="content.core.statement"
                render={({ field }) => <WYSIWYGEditor {...field} error={errors.content?.core?.statement} />}
              />
            </>
          )}

          <NumberedHeading number={renderTaskNumber(watch(`content.core.type_id`))} title="Task Title" instructions="Enter the exact name of the resulting task." required />
          <Controller
            control={control}
            name="content.core.task_title"
            render={({ field }) => (
              <TextField
                className="mt-16"
                {...field}
                label="Task Title"
                placeholder="Task Title"
                id="task_title"
                error={!!errors.content?.core?.task_title}
                helperText={errors.content?.core?.task_title?.message}
                variant="outlined"
                fullWidth
                required
              />
            )}
          />
        </>
      )}
    </div>
  );
};

export default PEInformativeEvent;